@if (artikel.helplines.length > 0) {
  <div class="bg-n-200 py-8 container container-space">
    <div class="container-1-col">
      <h2 class="typo-h3 mb-6">Praat erover</h2>
      <parkour-watwat-helplines [helplines]="artikel.helplines"></parkour-watwat-helplines>
    </div>
  </div>
}
